import { Injectable } from '@angular/core';
import { CommercialContact } from 'src/app/model/commercial-services/commercial-contact';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class CommercialContactTableService extends BaseTableService<CommercialContact> {}
